export default __webpack_public_path__ + "static/media/guwahati.a4dec91c.png";